import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c594fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forget-right" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("忘记账号或密码？")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "forget-tips" }, " 若忘记考试账号或密码，请在报名期间点击【立即报名】重新输入报名信息，找回考试账号或密码。 ", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    rules: _ctx.formRules,
    model: _ctx.formState,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        label: "",
        name: "account",
        class: "item-account"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            size: "large",
            maxlength: 20,
            value: _ctx.formState.account,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.account) = $event)),
            placeholder: "请输入账号"
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "",
        name: "password",
        class: "item-password"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input_password, {
            size: "large",
            maxlength: 11,
            value: _ctx.formState.password,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event)),
            placeholder: "请输入密码"
          }, null, 8, ["value"]),
          (_ctx.extraForgetTips)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_a_button, { type: "link" }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_3
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "",
        class: "pdt"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            size: "large",
            maxlength: 6,
            class: "item-button",
            type: "primary",
            shape: "round",
            block: "",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["rules", "model", "label-col", "wrapper-col"]))
}